import { render, staticRenderFns } from "./ImportCollection.vue?vue&type=template&id=a79da15e&"
import script from "./ImportCollection.vue?vue&type=script&lang=js&"
export * from "./ImportCollection.vue?vue&type=script&lang=js&"
import style0 from "./ImportCollection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports